import { fetchMainApi } from '@/api/index'
import { useUserStore } from '@/store/user'

export const updateProfilePicture = async (file) => {
  const userStore = useUserStore()
  const userId = userStore.user.id
  const formData = new FormData()
  formData.append('photo', file)
  return fetchMainApi(
    'POST',
    `/users/${userId}/photo`,
    {
      body: formData
    },
    'multipart/form-data'
  ).then(response => {
    useUserStore().updateUserPhoto(response.data.photo)
  })
}

export const patchSettings = async (updatedSettings) => {
  const userStore = useUserStore()
  return fetchMainApi('PATCH', '/users/' + userStore.user.id, {
    body: JSON.stringify(updatedSettings)
  })
}

export const getAccountDocuments = async (id) => {
  const url = id ? `/account-documents?account_id=${id}` : '/account-documents';
  return fetchMainApi('GET', url);
}

export const approveAccountDocument = (id) =>
  fetchMainApi('POST', `/account-documents/${id}/approve`)

export const deleteAccountDocument = (id) =>
  fetchMainApi('DELETE', `/account-documents/${id}`)

export const uploadAccountDocuments = async (files) => {
  const formData = new FormData()
  for(const file of files){
    formData.append('files[]', file.file)
  }
  formData.append('files', files)
  return fetchMainApi(
    'POST',
    '/account-documents',
    {
      body: formData
    },
    'multipart/form-data'
  )
}
